import { withStyles } from '@material-ui/core/styles';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './AdminMaintenanceLayout.styles';
import {
  AdminHeader,
  AdminFooter,
  AdminSideSlides,
  AdminMaintenanceMain
  // KioskIdelScreen
} from '..';
import { injectIntl, defineMessages } from 'react-intl';
import KioskIdelScreen from '../KioskLayout/KioskIdelScreen';
import AdminVideo from '../AdminImgCapture/AdminVideo';
import { connect } from 'react-redux';

const messages = defineMessages({
  WhatToDo: {
    id: 'Admin.Panel.WhatToDo',
    defineMessages: 'What are you here to do?'
  }
});

export class AdminMaintenanceLayout extends Component {
  static propTypes = {
    test: PropTypes.string
  };
  state = {
    stepTitle: '',
    pageTitle: this.props && this.props.intl.formatMessage(messages.WhatToDo),
    height: 300
  };

  render() {
    const { classes } = this.props;

    return (
      <div className={classNames(classes.container)}>
        <AdminVideo />
        <AdminHeader myLogoheight={this.state.height} />
        <AdminSideSlides
          pageTitle={this.state.pageTitle}
          customTop={this.state.customTop}
          customHeight={120}
        />
        <AdminMaintenanceMain />
        <AdminFooter customFooterBottom="0%" />
        <KioskIdelScreen />
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  const kiosk = state.get('kiosk');
  return { ...kiosk };
};

export default connect(mapStateToProps)(
  withStyles(styles, { withTheme: true })(injectIntl(AdminMaintenanceLayout))
);
